

import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import * as tableActions from '../../../store/actions/table';
import urls from "../../../utils/urls";
import Button from "react-bootstrap/Button";
import placeholder from "../../../assets/images/placeholder1.png";
import Nav from "react-bootstrap/Nav";
import Bound from "../../Common/Bound";
import Details from "./Profile/Details";
import Students from "./Profile/Students";
import SchoolEvents from "./Profile/SchoolEvents";

class SchoolProfile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            preview: '',
            image: '',
        }
    }


    componentDidMount(){
        this.init();
    }

    componentDidUpdate(props, state) {
        if(props.single.single !== this.props.single.single) {
            this.init();


        }


    }

    init = () => {
        if (this.props.single.single.image) {
            if (this.props.single.single.image.path) {
                this.setState({preview: urls.getS3Url(this.props.single.single.image.thumb || this.props.single.single.image.path)})
            }
        } else if (this.state.preview) {
            this.setState({preview: ''})

        }
    }

    menu = [
        {
            title: 'Details',
            path: `/app/schools/${this.props.match.params.id}/info`,
            component: <Details />,
            dataSet: () => {

                this.props.getSingle("users", this.props.user.user._id, this.props.auth.token._id);
            },
            protected: false
        },
        {
            title: 'Students',
            path: `/app/schools/${this.props.match.params.id}/students`,
            component: <Students />,
            protected: true
        },
        {
            title: 'Entries',
            path: `/app/schools/${this.props.match.params.id}/entries`,
            component: <SchoolEvents />,
            protected: true
        }
    ]

    renderItem = (item, i) => {

        let canRender = true;
        if (item.protected) {
            if ((this.props.user.user.role === 'admin') || 
            (this.props.single.single.admins.filter(admin => admin._id === this.props.user.user._id).length > 0) ||
            (this.props.single.single.moderators.filter(admin => admin._id === this.props.user.user._id).length > 0)) {
                canRender = true;
            } else {
                canRender = false;
            }
        }

        //console.log("TH", this.props.single.single.admins);
        if (canRender) {
            return (
                <Nav.Link key={i} to={item.path} as={Link}
                          className={`tab tab-${i} ${this.props.location.pathname === item.path ? 'active' : ''}`}>{item.title}</Nav.Link>
            )
        }else {
            return null;
        }
    }

    renderContent = () => {
        let menuItem = this.menu.filter(item => item.path === this.props.location.pathname);
        if (menuItem.length > 0) {
            return (
                <Bound>
                    {menuItem[0].component}
                </Bound>

            );
        } else {
            return null;
        }
    }


    render() {

        // User is a school admin or SuperAdmin
        let isAdmin = (this.props.user.user.role === 'admin') || 
            (this.props.single.single.admins && this.props.single.single.admins.filter(a => a._id === this.props.user.user._id).length > 0 )


        return (

            <div className={""}>
                {this.props.single.single._id === this.props.match.params.id || this.props.match.params.id === 'new' ?
                    <div>
                        <div className={"profile-header"}>
                            <div className={"artist-img avatar"} style={{background: this.state.preview ? `url(${this.state.preview}), linear-gradient(0deg, rgba(0,0,0,.6), rgba(0,0,0,.4), rgba(0,0,0,.2), transparent)` : `url(${placeholder}), linear-gradient(0deg, rgba(0,0,0,.6), rgba(0,0,0,.4), rgba(0,0,0,.2), transparent)`}}></div>

                                <h2 className={"profile-title"}>{this.props.single.single.name}</h2>
                                {isAdmin ?
                                    <Button variant={"flat"} onClick={e => this.props.history.push(`/app/schools/${this.props.match.params.id}/edit`)}>Edit</Button>
                                : null}
                            </div>
                            <div className={"profile-body"}>
                                <div className={"tab-container"}>
                                    <div className={"tab-row"}>
                                        {this.menu.map((item, i) => {
                                            return this.renderItem(item, i)
                                        })}
                                        <div className={"tab-highlight"} />
                                        <div className={"tab-highlight-track"} />
                                    </div>

                                </div>
                                <div className={"tab-content ex-pad"}>

                                    {this.renderContent()}

                                </div>
                            </div>
                        </div>
                    : null}

            </div>
        )
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    table: state.table,
    single: state.single,
    user: state.user
});

const mapDispatchToProps = dispatch => ({
    getTableData: (view, skip, limit, sort, token, mode) => {
        dispatch(tableActions.getTableDataWithQuery(view, skip, limit, sort, {}, token, mode));
    },
    getTableDataWithQuery: (view, skip, limit, sort, query, token, mode) => {
        dispatch(tableActions.getTableDataWithQuery(view, skip, limit, sort, query, token, mode));
    },
});

const Connected = withRouter(connect(mapStateToProps, mapDispatchToProps)(SchoolProfile));

class SchoolProfileContainer extends React.Component {
    render() {
        return (
            <div>
                <Connected {...this.props} />
            </div>
        )
    }
}

export default SchoolProfileContainer;
